import type { FC, ReactNode } from "react";
import type { ListData } from "react-stately";
import { MultiSelect } from "@/components/base/select/multi-select";
import type { SelectItemType } from "@/components/base/select/select";
import { useFieldContext } from "..";
import { FieldErrors } from "./FieldErrors";

interface MultiSelectFieldProps {
	label?: string;
	tooltip?: string;
	hint?: string;
	size?: "sm" | "md";
	placeholder?: string;
	placeholderIcon?: FC | ReactNode;
	popoverClassName?: string;
	items?: SelectItemType[];
	children: ReactNode | ((item: SelectItemType) => ReactNode);
	// MultiSelect specific props
	isDisabled?: boolean;
	shortcut?: boolean;
	selectedItems: ListData<SelectItemType>;
	field?: any; // Simplified for now - will be properly typed later
}

const MultiSelectField = ({
	label,
	tooltip,
	hint,
	size = "sm",
	placeholder = "Search",
	placeholderIcon,
	popoverClassName,
	items,
	children,
	isDisabled,
	shortcut = false,
	selectedItems,
	field: fieldProp,
	...props
}: MultiSelectFieldProps) => {
	// Support both patterns:
	// 1. form.Field with explicit field prop
	// 2. form.AppField with useFieldContext
	const contextField = useFieldContext<string[]>();
	const field = fieldProp || contextField;

	return (
		<div className="space-y-2">
			<MultiSelect
				{...props}
				label={label}
				tooltip={tooltip}
				hint={hint}
				size={size}
				placeholder={placeholder}
				// placeholderIcon={placeholderIcon} // TODO: Fix this prop
				popoverClassName={popoverClassName}
				items={items}
				isDisabled={isDisabled || field.state.meta.isValidating}
				isInvalid={field.state.meta.isTouched && !field.state.meta.isValid}
				isRequired={field.state.meta.isRequired}
				selectedItems={selectedItems}
				// onSelectionChange={handleSelectionChange} // TODO: Fix this handler signature
				onBlur={field.handleBlur}
				shortcut={shortcut}
			>
				{children}
			</MultiSelect>
			<FieldErrors meta={field.state.meta} />
		</div>
	);
};

export default MultiSelectField;
